import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Tab, Tabs} from 'react-bootstrap';
import {history} from '../../../../utils/redux/store';
import UnSavedModal from '../unSavedModal';
import {useSelector} from 'react-redux';
import _get from 'lodash/get';

export default function TabSection(dirty) {
  const accountSummary = useSelector(
    state => state.components.auth.accountSummary
  );
  const {privileges} = accountSummary;
  const {t} = useTranslation();
  const [tab, setTab] = useState('');
  const [newTab, setNewTab] = useState();
  const url = window.location.href;
  const [showDialog, setShowDialog] = useState(false);
  const version = _get(accountSummary, 'brandInfo.templateVersion');

  useEffect(() => {
    privileges.indexOf('P105_UI_CONFIGURATION') === -1 && history.push('/');
  }, []);

  useEffect(() => {
    switch (tab) {
      case 'C':
        history.push('/skincare-pro/ui-configuration/common-settings');
        return;
      case 'L':
        history.push('/skincare-pro/ui-configuration/landing-page');
        return;
      case 'L2':
        history.push('/skincare-pro/ui-configuration/landing');
        return;
      case 'S':
        history.push('/skincare-pro/ui-configuration/skincare-detection');
        return;
      case 'R':
        history.push('/skincare-pro/ui-configuration/skin-result-page');
        return;
      case 'R2':
        history.push('/skincare-pro/ui-configuration/skin-result');
        return;
      case 'G':
        history.push('/skincare-pro/ui-configuration/get-skin-result');
        return;
      default:
        return;
    }
  }, [tab]);

  useEffect(() => {
    const page = url
      .toString()
      .split('/')
      .pop();
    switch (page) {
      case 'common-settings':
        setTab('C');
        return;
      case 'landing-page':
        setTab('L');
        return;
      case 'landing':
        setTab('L2');
        return;
      case 'skincare-detection':
        setTab('S');
        return;
      case 'skin-result-page':
        setTab('R');
        return;
      case 'skin-result':
        setTab('R2');
        return;
      case 'get-skin-result':
        setTab('G');
        return;
      default:
        setTab('L');
        return;
    }
  }, [url]);

  const handleChange = e => {
    if (dirty && dirty.dirty === true) {
      setNewTab(e);
      setShowDialog(true);
    } else {
      setTab(e);
    }
  };

  return (
    <>
      <Tabs
        id="ui-config"
        className="nav nav-tabs nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-brand"
        defaultActiveKey="D"
        activeKey={tab}
        unmountOnExit={true}
        onSelect={handleChange}
      >
        {version === 2 && (
          <Tab
            eventKey="C"
            title={t(
              'p.s.uiconfiguration.tabs.common.settings',
              'Common Settings'
            )}
            className="nav-link"
          />
        )}
        <Tab
          eventKey={version === 1 ? 'L' : 'L2'}
          title={t('p.s.uiconfiguration.tabs.landingpage', 'Landing Page')}
          className="nav-link"
        />
        <Tab
          eventKey="S"
          title={t(
            'p.s.uiconfiguration.tabs.skincaredetection',
            'Skincare Detection'
          )}
          className="nav-link"
        />
        <Tab
          eventKey={version === 1 ? 'R' : 'R2'}
          title={t(
            'p.s.uiconfiguration.tabs.skinresultpage',
            'Skin Result Page'
          )}
          className="nav-link"
        />
        {version === 1 && (
          <Tab
            eventKey="G"
            title={t(
              'p.s.uiconfiguration.tabs.getskinresult',
              'Get Skin Result'
            )}
            className="nav-link"
          />
        )}
      </Tabs>
      <UnSavedModal
        showModal={showDialog}
        setShowModal={setShowDialog}
        handleLeave={() => setTab(newTab)}
      />
    </>
  );
}
